import { Card }                from 'antd';
import FormattedMessageWrapper from 'components/App/FormattedMessageWrapper';

const contents = [
  {
    bold: true,
    text: <FormattedMessageWrapper id="Identité du responsable du traitement des données" />,
  },
  {
    bold: false,
    text: (
      <>
        <FormattedMessageWrapper id="L’administrateur et le responsable de la collecte du site" />{' '}
        <u>astech-prod.com</u> :
      </>
    ),
  },
  {
    bold: false,
    text: (
      <>
        Pascal REDON.
        <br />
        DSFA 1 LES GELINOTTES 78170 LA CELLE SAINT CLOUD. FRANCE.
      </>
    ),
  },
  {
    bold: false,
    text: 'pascal.redon@astech-prod.com',
  },
  {
    bold: false,
    text: 'SIRET : 423 556 984 00031.',
  },
  {
    bold: true,
    text: <FormattedMessageWrapper id="Prestation ASTECH-PROD :" />,
  },
  {
    bold: false,
    text: (
      <>
        <FormattedMessageWrapper id="L’accès à la plate-forme ASTECH-PROD est exclusivement réservé à un usage professionnel. Les organisateurs de salon confient à l’administrateur de la plate-forme une mission de contrôle et de validation des plans des stands de leurs exposants." />
        <br />
        <FormattedMessageWrapper id="La connexion à la plate-forme ASTECH-PROD pour les organisateurs et pour leurs exposants ne peut se faire qu’avec un identifiant et un mot de passe durant la période de la prestation." />
      </>
    ),
  },
  {
    bold: false,
    text: (
      <FormattedMessageWrapper id="La plate-forme ASTECH-PROD n’est plus accessible aux organisateurs et à leurs exposants une fois la prestation terminée." />
    ),
  },
  {
    bold: true,
    text: (
      <FormattedMessageWrapper id="Définition de la notion de : « données à caractère personnel »" />
    ),
  },
  {
    bold: false,
    text: (
      <FormattedMessageWrapper id="Une « donnée personnelle » ou « donnée à caractère personnel » est « toute information se rapportant à une personne physique identifiée ou identifiable ». Une personne peut être identifiée soit directement (exemple : nom, prénom) ; soit indirectement (par un identifiant ou un numéro de client, un numéro de téléphone une donnée biométrique, plusieurs éléments spécifiques propres à son identité physique, physiologique, génétique, psychique, économique, culturelle ou sociale, mais aussi la voix ou l’image)." />
    ),
  },
  {
    bold: true,
    text: (
      <FormattedMessageWrapper id="Usage sur notre plate-forme des données à caractère personnel :" />
    ),
  },
  {
    bold: false,
    text: (
      <>
        <FormattedMessageWrapper id="Les données ( liste exposants ) qui nous sont confiées par notre client ( l’organisateur du salon ) ne servent qu’à contacter, recevoir des documents et dialoguer avec les exposants par voie d’email pour l’exécution de notre prestation." />
        <br />
        <FormattedMessageWrapper id="Les exposants faisant appel à des prestataires pour la gestion de leur stand nous fournissent leurs coordonnées qui sont enregistrées dans les contacts correspondant à leur stand." />
      </>
    ),
  },
  {
    bold: false,
    text: (
      <FormattedMessageWrapper id="En aucun cas, les données concernant les exposants fournis par les organisateurs ne sont cédées, vendues ou utilisées par des tiers ou partenaires commerciaux pour quelque usage que ce soit. Cette liste exposant reste la propriété exclusive des organisateurs du salon." />
    ),
  },
  {
    bold: false,
    text: (
      <FormattedMessageWrapper id="Les contenus générés par la prestation, échanges de mails et de pièces jointes, reste la propriété de la plate-forme ASTECH-PROD sur laquelle ces échanges ont été recueillis et enregistrés." />
    ),
  },
  {
    bold: true,
    text: 'Durée de conservation des données :',
  },
  {
    bold: false,
    text: (
      <>
        <FormattedMessageWrapper id="Une demande d’archivage peut-être commandée par l’organisateur du salon à l’administrateur, elle concerne les échanges emails et les pièces jointes découlant de la prestation. La durée d’archivage est définie entre l’organisateur et le responsable de la plate-forme ASTECH-PROD." />
        <br />
        <FormattedMessageWrapper id="Durant cette période d’archivage l’organisateur et ses exposants ont toujours accès à la plateforme et à leur dossier." />
      </>
    ),
  },
  {
    bold: false,
    text: (
      <FormattedMessageWrapper id="Si aucune prestation d’archivage n’est commandée par l’organisateur, les données concernant la liste des exposants sont supprimées de notre plate-forme ASTECH-PROD à la fin de notre prestation." />
    ),
  },
  {
    bold: true,
    text: <FormattedMessageWrapper id="Stockage sécurisé de vos données" />,
  },
  {
    bold: false,
    text: (
      <FormattedMessageWrapper id="Nous sommes particulièrement vigilants aux conditions de stockage de vos données personnelles recueillies dans le but unique du bon fonctionnement de nos échanges pour notre prestation." />
    ),
  },
  {
    bold: false,
    text: (
      <>
        <FormattedMessageWrapper id="Les données sont stockées dans une base de données sise sur un serveur hautement sécurisé bénéficiant d’une maintenance régulière et de mises à jour de sécurité périodiques effectuées par une société spécialisée dans l’infogérance des serveurs." />
        <br />
        <FormattedMessageWrapper id="Les seules personnes autorisées à traiter vos données sur la plate-forme Astech-Prod.com ont accès à celle-ci via des interfaces sécurisées." />
      </>
    ),
  },
  {
    bold: false,
    text: (
      <FormattedMessageWrapper id="Au-delà de tous nos efforts cependant, nous ne pouvons garantir à 100 % la sécurité totale de vos données, les environnements informatiques possédant leurs limites et failles potentielles propres." />
    ),
  },
  {
    bold: true,
    text: <FormattedMessageWrapper id="Vos droits d'accès, de modification et d’opposition" />,
  },
  {
    bold: false,
    text: (
      <FormattedMessageWrapper id="Vous bénéficiez des droits prévus par la loi n°78-17 du 6 janvier 1978 relative à l'informatique, aux fichiers et aux libertés en particulier pour ce qui concerne l’accès à vos données, leur rectification et votre opposition à la collecte et à la conservation de ces dernières." />
    ),
  },
  {
    bold: false,
    text: (
      <>
        <FormattedMessageWrapper id="Vous pouvez à tout moment demander la modification ou la suppression de vos données en envoyant un courrier électronique à pascal.redon@astech-prod.com Votre demande sera immédiatement prise en considération dès réception de votre courrier électronique et traitée dans les plus bref délais." />
        <br />
        <FormattedMessageWrapper id="Toutes demandes de suppression de vos données annule automatiquement la possibilité de traiter le dossier concernant la validation des plans de votre stand." />
      </>
    ),
  },
];

const LegalMentions = () => (
  <Card
    className="accented-shadow"
    style={{
      margin: '0px auto',
      maxWidth: '800px',
      marginTop: '16px',
    }}
  >
    <h2>
      <FormattedMessageWrapper id="Mentions légales" />
    </h2>

    {contents.map(((content, index) => (
      <p key={index}>{content.bold ? <b>{content.text}</b> : content.text}</p>
    )))}
  </Card>
);

export default LegalMentions;
